import React, { useEffect, useState } from 'react';
import axios from "axios";
import { newBaseUrl } from "../../../Consts";
import { useNavigate, useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import LoadingOverlay from '../../LoadingOverlay/LoadingOverlay';
import { useContact } from '../../../Context/ContactUsContext';

function EditContactForm() {
    const { isContactById, getContactById } = useContact();
    const { id } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getContactById(id);
    }, []);


    const handleSaveClick = async () => {
        setLoading(true);
        try {
            const body = {
                'name': document.getElementById('name').value,
                'address': document.getElementById('address').value,
                'tel': document.getElementById('phone').value,  // <-- fix here
                'mail': document.getElementById('mail').value,
                'directions': document.getElementById('directions').value,
            };
            const response = await axios.post(`${newBaseUrl}/api/update/contact/${id}`, body, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${localStorage.getItem("token")}`
                },
            });
            toast.success('Contact updated successfully!', {
                onClose: () => {
                    navigate(`/Pages/ContactUs/${isContactById?.data.lang_id === 1 ? "en" : "ar"}`, { replace: true });
                    setLoading(false);
                },
            });
        } catch (err) {
            // Check if there are validation errors in the response
            if (err.response && err.response.data && err.response.data.errors) {
                // Loop through each error message and display it
                const errors = err.response.data.errors; // Assuming `errors` is an object or array
                for (const key in errors) {
                    if (errors.hasOwnProperty(key)) {
                        errors[key].forEach((message) => {
                            toast.error(message); // Display each error message
                        });
                    }
                }
            } else if (err.response && err.response.data && err.response.data.message) {
                // Display a single error message if available
                toast.error(err.response.data.message);
            } else {
                // Handle other errors
                toast.error("An unexpected error occurred.");
            }
            setLoading(false)
        }
    };

    return (
        <div>
            <ToastContainer autoClose={3000} pauseOnFocusLoss={false} pauseOnHover={false} />
            {(loading || !isContactById) ? <LoadingOverlay /> :
                <div className="flex justify-start bg-[#fff] rounded-lg py-[50px] px-[50px]">
                    <div className='scrollable-content px-[50px]' style={{ width: '100%' }}>
                        <label className="block text-start text-[16px] font-[400] font-[Cairo] pb-1">
                            Name
                        </label>
                        <input type={'text'} id={'name'} name={'name'}
                            className="border rounded-lg text-[13px] font-[400] font-[Cairo] mb-2 p-2 w-full h-[40px] border-[#DFEAF2] custom-placeholder-style"
                            placeholder={`Type title here`}
                            defaultValue={isContactById?.data?.name}
                            style={{ paddingBottom: "8px" }}
                        />

                        <label className="block text-start text-[16px] font-[400] font-[Cairo] pb-1">
                            Phone
                        </label>
                        <input type={'text'} id={'phone'} name={'phone'}
                            className="border rounded-lg text-[13px] font-[400] font-[Cairo] mb-2 p-2 w-full h-[40px] border-[#DFEAF2] custom-placeholder-style"
                            placeholder={`Type title here`}
                            defaultValue={isContactById?.data?.tel}
                            style={{ paddingBottom: "8px" }}
                        />

                        <label className="block text-start text-[16px] font-[400] font-[Cairo] pb-1">
                            Mail
                        </label>
                        <input type={'text'} id={'mail'} name={'mail'}
                            className="border rounded-lg text-[13px] font-[400] font-[Cairo] mb-2 p-2 w-full h-[40px] border-[#DFEAF2] custom-placeholder-style"
                            placeholder={`Type title here`}
                            defaultValue={isContactById?.data?.mail}
                            style={{ paddingBottom: "8px" }}
                        />

                        <label className="block text-start text-[16px] font-[400] font-[Cairo] pb-1">
                            Address
                        </label>
                        <input type={'text'} id={'address'} name={'address'}
                            className="border rounded-lg text-[13px] font-[400] font-[Cairo] mb-2 p-2 w-full h-[40px] border-[#DFEAF2] custom-placeholder-style"
                            placeholder={`Type title here`}
                            defaultValue={isContactById?.data?.address}
                            style={{ paddingBottom: "8px" }}
                        />

                        <label className="block text-start text-[16px] font-[400] font-[Cairo] pb-1">
                            Directions
                        </label>
                        <input type={'text'} id={'directions'} name={'directions'}
                            className="border rounded-lg text-[13px] font-[400] font-[Cairo] mb-2 p-2 w-full h-[40px] border-[#DFEAF2] custom-placeholder-style"
                            placeholder={`Type title here`}
                            defaultValue={isContactById?.data?.directions}
                            style={{ paddingBottom: "8px" }}
                        />

                        <div>
                            <button className="bg-[#0966AE] text-[#fff] rounded-lg py-2 my-3 w-[200px] text-[20px] font-[Cairo]"
                                onClick={handleSaveClick}
                                disabled={loading}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default EditContactForm;
